import { Injectable } from '@angular/core';
import { MessageService } from 'primeng/api';
import { AvanoActionFeedback, AvanoCustomMessage, AvanoMessage, AvanoMessageCategory, AvanoMessageType, AvanoNotification } from './avano-toaster.interfaces';
import { AVANO_TOASTER_KEY } from './avano-toaster/avano-toaster.component';

@Injectable({
  providedIn: 'root'
})
export class AvanoToasterService {

  constructor(private messageService: MessageService) {}

  pushFeedback(feedback: AvanoActionFeedback): void {
    this.messageService.add(AvanoActionFeedback.toMessage(feedback))
  }
  pushNotification(message: AvanoNotification): void {
    this.messageService.add(AvanoNotification.toMessage(message));
  }
  pushCustomMessage<T>(message: AvanoCustomMessage<T>): void {
    this.messageService.add(AvanoCustomMessage.toMessage(message));
  }

  addAll(messages: AvanoNotification[]): void {
    this.messageService.addAll(messages.map(AvanoNotification.toMessage));
  }
  clear(key?: string): void {
    this.messageService.clear(key);
  }
}

const AvanoNotification = {
  toMessage: (notification: AvanoNotification): AvanoMessage => {
    const {icon, styleClass} = getCategoryIcon(notification.category);
    return {
      key: AVANO_TOASTER_KEY,
      messageType: AvanoMessageType.notification,
      icon: icon,
      styleClass: styleClass,
      closable: true,
      life: notification.lifeTime,
      contentStyleClass: 'avano-notification',
      summary: notification.title,
      detail: notification.description,
      data: {
        detailsButton: notification.detailsButton
      },
    }
  }
}
const AvanoActionFeedback = {
  toMessage: (feedbackAction: AvanoActionFeedback): AvanoMessage => {
    const {icon, styleClass} = getCategoryIcon(feedbackAction.category);
    return {
      messageType: AvanoMessageType.feedback,
      key: AVANO_TOASTER_KEY,
      icon: icon,
      styleClass: styleClass,
      closable: false,
      life: feedbackAction.lifeTime,
      contentStyleClass: 'avano-action-feedback',
      summary: feedbackAction.text,
    }
  }
}
const AvanoCustomMessage = {
  toMessage: (customMessageDetails: AvanoCustomMessage): AvanoMessage => {
    return {
      messageType: AvanoMessageType.custom,
      key: AVANO_TOASTER_KEY,
      closable: false,
      messageDetails: customMessageDetails,
    }
  }
}
function getCategoryIcon(category: AvanoMessageCategory): {icon: string, styleClass: string} {
  switch(category) {
    case AvanoMessageCategory.info:
      return {icon: 'icon-content-info', styleClass: 'avano-info'};
    case AvanoMessageCategory.warning:
      return {icon: 'icon-content-warning', styleClass: 'avano-warning'};
    case AvanoMessageCategory.error:
      return {icon: 'icon-content-error', styleClass: 'avano-error'};
    case AvanoMessageCategory.success:
      return {icon: 'icon-content-success', styleClass: 'avano-success'};
    case AvanoMessageCategory.appinfo:
      return {icon: 'icon-content-logo', styleClass:'avano-appinfo'};
  }
}